export default "__VITE_ASSET__CO6IqC3v__"